import { CustomPropertiesAddress, WoosmapFeature } from '../../data/woosmap/woosmapSdk'
import { LazyDropOffSchedule } from './DropOffSchedule'

export interface DropOffLocationAddress {
  line: string
  zipCode: string
  countryCode: string
  city: string
  province?: string
}

export interface DropOffLocationContact {
  phone?: string
  website?: string
}

export interface DropOffDaySchedule {
  openHours: DropOffOpenCloseHour[]
}

export interface DropOffOpenCloseHour {
  opening: string
  closing: string
}

export interface DropOffLocationCoordinate {
  latitude: number
  longitude: number
}

export interface DropOffLatLngLiteral {
  lat: number
  lng: number
}

export interface IDropOffLocationProps {
  storeId: string
  tenantId?: string
  wasteBoxId?: string
  name: string
  tags?: Array<string>
  types?: Array<string>
  pictures?: Array<string>
  address?: DropOffLocationAddress
  coordinate: DropOffLocationCoordinate
  contact?: DropOffLocationContact
  acceptedWasteIds?: Array<string>
  schedule?: LazyDropOffSchedule
  isOpenNow: boolean
  brandProgram?: string
}

class DropOffLocation {
  public readonly storeId: string
  public readonly tenantId?: string
  public readonly wasteBoxId?: string
  public readonly address?: DropOffLocationAddress
  public readonly name: string
  public readonly tags: Array<string>
  public readonly types: Array<string>
  public readonly pictures: Array<string>
  public readonly coordinate: DropOffLocationCoordinate
  public readonly contact?: DropOffLocationContact
  public readonly acceptedWasteIds: Array<string>
  public readonly schedule?: LazyDropOffSchedule
  public readonly isOpenNow: boolean
  public readonly brandProgram?: string

  constructor({
    storeId,
    tenantId,
    wasteBoxId,
    address,
    name,
    tags,
    types,
    pictures,
    coordinate,
    acceptedWasteIds,
    contact,
    schedule,
    isOpenNow,
    brandProgram
  }: IDropOffLocationProps) {
    this.storeId = storeId
    this.tenantId = tenantId
    this.wasteBoxId = wasteBoxId
    this.name = name
    this.tags = tags || []
    this.types = types || []
    this.pictures = pictures || []
    this.address = address
    this.coordinate = coordinate
    this.acceptedWasteIds = acceptedWasteIds || []
    this.contact = contact
    this.schedule = schedule
    this.isOpenNow = isOpenNow
    this.brandProgram = brandProgram
  }

  get firstPicture(): string | undefined {
    if (this.pictures.length > 0) {
      return this.pictures[0]
    }
    return undefined
  }

  toWoosmapFeature(): WoosmapFeature {
    let address: CustomPropertiesAddress | undefined = undefined
    if (this.address) {
      address = {
        lines: [this.address.line],
        zipcode: this.address.zipCode,
        city: this.address.city,
        country_code: this.address.countryCode
      }
    }

    return {
      geometry: {
        type: 'Point',
        coordinates: [this.coordinate.longitude, this.coordinate.latitude]
      },
      properties: {
        store_id: this.storeId,
        contact: null,
        name: this.name,
        address,
        tags: this.tags,
        types: this.types,
        user_properties: null
      },
      type: 'Feature'
    }
  }

  getPosition(): DropOffLatLngLiteral {
    return {
      lat: this.coordinate.latitude,
      lng: this.coordinate.longitude
    }
  }
}

export default DropOffLocation
